import React, { useEffect, useState } from 'react';
import { Button, Container, SearchInput } from '../../../components';
import AlternateProductTable from './AlternateProductTable';
import { IoMdAdd } from 'react-icons/io';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import CreateAlternateProduct from './CreateAlternateProduct';
import { useAlternateProduct } from '../../../context/alternateProductContext/AlternateProductContextProvider';
import { useDebouncedCallback } from '@/utils/useDebouncedCallback';

const AlternateProductView = () => {
  const { openModal, closeModal } = useModal();
  const {
    searchQuery,
    setSearchQuery,
    getAlternateProducts,
    clearFormData,
    setCurrentPage,
    currentPage,
  } = useAlternateProduct();

  const [inputValue, setInputValue] = useState(searchQuery || '');

  const handleOpenModal = () => {
    clearFormData();
    openModal(
      <CreateAlternateProduct closeModal={closeModal} />,
      'Create Alternate Product',
    );
  };

  const debouncedSetSearchQuery = useDebouncedCallback((val) => {
    setSearchQuery(val);
  }, 300);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debouncedSetSearchQuery.call(val);
  };
  useEffect(() => {
    setSearchQuery(searchQuery); // update context value
    setCurrentPage(0);
    getAlternateProducts(); // only gets called after debounce
  }, [searchQuery]);

  return (
    <Container title="Alternate Product">
      <div className="lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3 ">
        <SearchInput value={inputValue} onChange={handleSearchChange} />
        <div className="lg:mt-0 flex justify-center mt-2">
          <Button onClick={handleOpenModal}>
            <div>Add Alternate Product</div>
            <div>
              <IoMdAdd />
            </div>
          </Button>
        </div>
      </div>
      <AlternateProductTable />
    </Container>
  );
};

const App = () => (
  <ModalProvider>
    <AlternateProductView />
  </ModalProvider>
);

export default App;
